import React, { Component } from "react";
import { Button } from "@appcues/component-library";
import BaseModal from "components/ModalContainer/BaseModal";
import gif from "assets/images/close.gif";

import "components/ModalContainer/InstallModal/style.scss";

export default class InstallModal extends Component {
  render() {
    return (
      <BaseModal
        modalClass="install-modal"
        okText={`I'll do this later`}
        shouldHideButtonStyle
        {...this.props}
      >
        <div className="center-content">
          <img alt="Install" src={gif} />
          <h4>Almost there...</h4>
          <p>
            This content has been staged for publishing until you've installed
            the Appcues SDK. Once the SDK is installed, your users can instantly
            see your published content.
          </p>
          <br />
          <Button className="button-primary" href="/settings/installation">
            Install the Appcues SDK
          </Button>
          <p className="muted">(Takes less than 15 minutes)</p>
        </div>
      </BaseModal>
    );
  }
}
